import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { nanoid } from 'nanoid';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import ContentCard from '../../common/ContentCard';

function FiltersDrawer({
    filterDrawerOpen,
    hideFilters,
    locationState,
    allLocationsForFilter,
    allZones,
    zoneState,
    UNASSIGNED,
    ASSIGNED,
    IN_PROGRESS,
    SUBMITTED,
    SKIPPED,
    ACCEPTED,
    REJECTED,
    handleTaskStatusFilterChange,
}) {
    const [unassignedInput, setUnassigned] = useState(UNASSIGNED);
    const [assignedInput, setAssigned] = useState(ASSIGNED);
    const [submittedInput, setSubmitted] = useState(SUBMITTED);
    const [inProgressInput, setInProgress] = useState(IN_PROGRESS);
    const [skippedInput, setSkipped] = useState(SKIPPED);
    const [acceptedInput, setAccepted] = useState(ACCEPTED);
    const [rejectedInput, setRejected] = useState(REJECTED);

    return (
        <div>
            <Drawer
                anchor="right"
                open={filterDrawerOpen}
                onClose={hideFilters}
            >
                <Box sx={{ width: 500 }} role="presentation">
                    <ContentCard
                        className="mx-2 my-4"
                        heading="Task Status"
                        subHeading="Filter by the status of a task."
                        content={
                            <>
                                <div className="m-2">
                                    <div className="row">
                                        <FormGroup>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={
                                                            unassignedInput
                                                        }
                                                        onChange={() => {
                                                            // update UI
                                                            setUnassigned(
                                                                !unassignedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'UNASSIGNED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Unassigned"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={assignedInput}
                                                        onChange={() => {
                                                            // update UI
                                                            setAssigned(
                                                                !assignedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'ASSIGNED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Assigned"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={
                                                            inProgressInput
                                                        }
                                                        onChange={() => {
                                                            // update UI
                                                            setInProgress(
                                                                !inProgressInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'IN_PROGRESS',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="In Progress"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={submittedInput}
                                                        onChange={() => {
                                                            // update UI
                                                            setSubmitted(
                                                                !submittedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'SUBMITTED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Submitted"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={skippedInput}
                                                        onChange={() => {
                                                            // update UI
                                                            setSkipped(
                                                                !skippedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'SKIPPED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Skipped"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={acceptedInput}
                                                        onChange={() => {
                                                            // update UI
                                                            setAccepted(
                                                                !acceptedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'ACCEPTED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Accepted"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={rejectedInput}
                                                        onChange={() => {
                                                            // update UI
                                                            setRejected(
                                                                !rejectedInput,
                                                            );
                                                            handleTaskStatusFilterChange(
                                                                'REJECTED',
                                                            );
                                                        }}
                                                    />
                                                }
                                                label="Rejected"
                                            />
                                        </FormGroup>
                                    </div>
                                </div>
                            </>
                        }
                    />
                    <ContentCard
                        className="mx-2 my-4"
                        heading="Zone"
                        subHeading="Only show tasks from the following zones:"
                        content={
                            <>
                                <div className="m-2">
                                    {allZones && allZones.length > 0 ? (
                                        <>
                                            <div className="row">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={
                                                                zoneState.allZoneFilterChecked
                                                            }
                                                            onChange={
                                                                zoneState.handleAllZoneFilterChange
                                                            }
                                                            color="primary"
                                                        />
                                                    }
                                                    label="All Zones"
                                                />
                                            </div>
                                            <div className="row">
                                                <FormControl>
                                                    <FormHelperText>
                                                        Hold Ctrl or Command to
                                                        multi-select or
                                                        de-select
                                                    </FormHelperText>
                                                    <select
                                                        id="drawer-filter-zones"
                                                        name="zones"
                                                        multiple
                                                        value={
                                                            zoneState.filterZoneValue
                                                        }
                                                        onChange={
                                                            zoneState.handleFilterZonesChange
                                                        }
                                                        disabled={
                                                            zoneState.allZoneFilterChecked
                                                        }
                                                    >
                                                        {allZones.map(
                                                            (zone) => {
                                                                if (zone) {
                                                                    return (
                                                                        <option
                                                                            key={nanoid()}
                                                                            value={
                                                                                zone.id
                                                                            }
                                                                            sx={{
                                                                                p: 2,
                                                                            }}
                                                                        >
                                                                            {
                                                                                zone.name
                                                                            }
                                                                        </option>
                                                                    );
                                                                } else {
                                                                    <></>;
                                                                }
                                                            },
                                                        )}
                                                    </select>
                                                </FormControl>
                                            </div>
                                        </>
                                    ) : (
                                        <FormHelperText>
                                            No Valid Zones
                                        </FormHelperText>
                                    )}
                                </div>
                            </>
                        }
                    />
                    <ContentCard
                        className="mx-2 my-4"
                        heading="Location"
                        subHeading="Only show tasks from the following locations:"
                        content={
                            <>
                                <div className="m-2">
                                    <div className="row">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={
                                                        locationState.allLocationFilterChecked
                                                    }
                                                    onChange={
                                                        locationState.handleAllLocationFilterChange
                                                    }
                                                    color="primary"
                                                />
                                            }
                                            label="All Locations"
                                        />
                                    </div>
                                    <div className="row">
                                        <FormControl>
                                            <FormHelperText>
                                                Hold Ctrl or Command to
                                                multi-select or de-select
                                            </FormHelperText>
                                            <select
                                                id="drawer-filter-locations"
                                                name="locations"
                                                multiple
                                                value={
                                                    locationState.filterLocationsValue
                                                }
                                                onChange={
                                                    locationState.handleFilterLocationsChange
                                                }
                                                disabled={
                                                    locationState.allLocationFilterChecked
                                                }
                                            >
                                                {allLocationsForFilter.map(
                                                    (location) => {
                                                        return (
                                                            <option
                                                                key={nanoid()}
                                                                value={
                                                                    location.id
                                                                }
                                                                sx={{ p: 2 }}
                                                            >
                                                                {location.name}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </select>
                                        </FormControl>
                                    </div>
                                </div>
                            </>
                        }
                    />
                </Box>
            </Drawer>
        </div>
    );
}

FiltersDrawer.propTypes = {
    filterDrawerOpen: PropTypes.bool,
    hideFilters: PropTypes.func,
    allLocationsForFilter: PropTypes.arrayOf(PropTypes.object),
    allZones: PropTypes.arrayOf(PropTypes.object),
    locationState: PropTypes.object,
    zoneState: PropTypes.object,
    UNASSIGNED: PropTypes.bool,
    ASSIGNED: PropTypes.bool,
    IN_PROGRESS: PropTypes.bool,
    SUBMITTED: PropTypes.bool,
    SKIPPED: PropTypes.bool,
    ACCEPTED: PropTypes.bool,
    REJECTED: PropTypes.bool,
    handleTaskStatusFilterChange: PropTypes.func,
};

FiltersDrawer.defaultProps = {
    filterDrawerOpen: false,
    locationState: {
        allLocationFilterChecked: true,
    },
};

export default React.memo(FiltersDrawer);
